import { LightbulbOnOutlineIcon } from './LightbulbOnOutlineIcon';

/**
 * author: Austin Andrews
 * id 1FDA626F-5858-43AE-92A0-9CCE7168F08F
 * name lightbulb-on-outline
 * version: 1.8.36
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lightbulb-on-outline.svg
 * tags
 * - Home Automation 
 */
export const BulbOnOutlineIcon = LightbulbOnOutlineIcon;
export default BulbOnOutlineIcon